/**
 * Product Filters Toggle
 * 
 * @since 1.0.0
 */

export default () => {
  const container = document.querySelector('.js-product-filter-toggle')
  if (!container) return

  let triggers = container.querySelectorAll('.js-product-filter-toggle-trigger')
  let panels = container.querySelectorAll('.js-product-filter-toggle-panel')
  let closers = container.querySelectorAll('.js-product-filter-toggle-close')

  if ( triggers.length < 1 || panels.length < 1 || (triggers.length !== panels.length) ) return

  ;[...triggers].forEach( trigger => {
    trigger.addEventListener('click', addActive)
  })

  if ( closers.length > 1 ) {
    ;[...closers].forEach( closer => {
      closer.addEventListener('click', closeAll )
    })
  }

  /**
   * Toggle .active classes if click a trigger
   */
  function addActive(e) {
    const clickedTrigger = e.target.closest('.js-product-filter-toggle-trigger')
    const name = clickedTrigger.dataset.name
    const matchingPanel = container.querySelector(`.js-product-filter-toggle-panel[data-name=${name}]`)

    // Toggle .active if clicking the same trigger twice
    if ( clickedTrigger.classList.contains('active') ) {
      clickedTrigger.classList.remove('active')
      matchingPanel.classList.remove('active')
      return

    // Set new .active
    } else {
      closeAll()
      clickedTrigger.classList.add('active')
      matchingPanel.classList.add('active')
    }
  }

  /**
   * Remove all .active classes
   */
  function closeAll() {
    ;[...triggers].forEach(trigger => {
      if (trigger.classList.contains('active')) {
        trigger.classList.remove('active')
      }
    })
  
    ;[...panels].forEach(panel => {
      if (panel.classList.contains('active')) {
        panel.classList.remove('active')
      }
    })
  }

}


// WEBPACK FOOTER //
// ./src/js/woocommerce/ProductFilterToggle.js